// Search here. https://remixicon.com/

export const icons = {
    "mm-modules" : "ri-apps-line",
    "mm-unselected": "ri-checkbox-blank-line",
    "mm-selected": "ri-checkbox-line",
    "mm-service-info": "ri-server-line",
    "mm-users": "ri-user-line",
    "mm-roles": "ri-shield-line",
    "mm-department-roles": "ri-building-4-line",
    "mm-departments": "ri-building-4-line",
    "mm-select-all": "ri-checkbox-multiple-line",
    "mm-clear-all": "ri-checkbox-blank-line",
    "mm-add": "ri-add-line",
    "mm-delete": "ri-delete-bin-line",
    "mm-info": "ri-information-line",
    "mm-search": "ri-search-line",
    "mm-filter-clear": "ri-filter-off-line",
    "mm-add-all": "ri-add-circle-line",
    "mm-page-permissions": "ri-shield-star-line",
    "mm-entity-permissions": "ri-shield-flash-line",
    "mm-user-roles": "ri-shield-user-line",
    "mm-sessions": "ri-computer-line"
}
